var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcHeartFull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.667969 5.99761C0.667969 3.57071 2.26444 1.33203 4.95464 1.33203C6.20676 1.33203 7.13637 1.8685 7.83464 2.67234C8.5329 1.8685 9.4625 1.33203 10.7146 1.33203C13.4048 1.33203 15.0013 3.57071 15.0013 5.99761C15.0013 8.10538 14.0248 9.79671 12.682 11.1402C11.3456 12.4774 9.6227 13.4958 8.0583 14.2783C7.9175 14.3487 7.75177 14.3487 7.61097 14.2783C6.04659 13.4958 4.32361 12.4774 2.98725 11.1402C1.64451 9.79671 0.667969 8.10538 0.667969 5.99761Z",
    fill: "#5E9222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHeartFull);
export default __webpack_public_path__ + "static/media/ic-heart-full.af38cf0b6d55423e37198fa956b342b4.svg";
export { ForwardRef as ReactComponent };